import React, { Component } from "react";
import { Trans, withTranslation } from 'react-i18next'
import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Grid, Paper, Stack, TextField, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonGridHeader, { CommonEditButton } from "../../../Components/Common Components/CommonComponents";

class AssetSubCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Category_Name: null,
            Sub_Category_Name: "",
            isEdit: false,
            CategoryList: [],
            Sub_Category_List: [],
            current_page: 0,
            rowsPerPage: 10,
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: "",
            isActive: true,
            edit_id: null,
            isLoader: false
        }
    }

    componentDidMount() {
        this.getCategoryNameList()
        this.getSubCategoryList()
    }

    getCategoryNameList = () => {
        try {
            RestAPIService.getAll(Serviceurls.ASSET_CATEGORY_GET_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let data = response.data.data
                        let activeData = data.filter((item) => item?.active_status == true)
                        this.setState({
                            CategoryList: activeData
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.responseSuccessErrorMessage(error.response.data.message, false)
                    } else {
                        this.responseSuccessErrorMessage(error.message, false)
                    }
                })
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false);
        }
    }

    getSubCategoryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.ASSET_SUB_CATEGORY_GET_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            Sub_Category_List: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.responseSuccessErrorMessage(error.response.data.message, false)
                    } else {
                        this.responseSuccessErrorMessage(error.message, false)
                    }
                })
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false);
        }
    }

    handleSave = () => {
        const { t } = this.props
        let { Category_Name, isActive, edit_id, Sub_Category_Name } = this.state
        let data = {};
        if (Category_Name != null && Sub_Category_Name != "") {
            data = {
                "id": edit_id ? edit_id : null,
                "category_id": Category_Name?.id,
                "sub_category_name": Sub_Category_Name,
                "active_status": isActive
            }
            let RestAPI = edit_id ? RestAPIService.updateWithOutId(data, Serviceurls.ASSET_SUB_CATEGORY_GET_POST) : RestAPIService.create(data, Serviceurls.ASSET_SUB_CATEGORY_GET_POST)
            try {
                this.setState({ isLoader: true })
                RestAPI.then(response => {
                    if (response.data.status === "success") {
                        this.setState({ isLoader: false }, () => {
                            this.handleClear();
                            this.getSubCategoryList();
                        })
                        this.responseSuccessErrorMessage(response.data.message, true);
                    }
                })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.setState({ isLoader: false })
                            this.responseSuccessErrorMessage(error.response.data.message, false);
                        }
                    });
            } catch (e) {
                this.setState({ isLoader: false })
                this.responseSuccessErrorMessage(e.message, false);
            }
        } else {
            this.responseSuccessErrorMessage("Mandatory Fields Should not be empty", false);
        }
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }

    msgClose() {
        this.setState({
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: ''
        })
    }

    handleEdit = (item) => {
        let states = this.state
        let categoryName = this.state.CategoryList.filter((list) => list?.id == item?.category_id)
        states["isEdit"] = true
        states["edit_id"] = item?.id
        states["Sub_Category_Name"] = item?.sub_category_name
        states["Category_Name"] = categoryName[0]
        states["isActive"] = item?.active_status
        this.setState({ states })
    }

    handleClear = () => {
        this.setState({
            Category_Name: null,
            Sub_Category_Name: "",
            isActive: true,
            edit_id: null,
            isEdit: false
        })
    }

    render() {
        const { t } = this.props;
        let { rowsPerPage, current_page, Sub_Category_List, } = this.state;
        const columns = [
            { field: 's.no', headerName: t('SNo'), sortable: false, flex: 0.06, renderCell: (index) => index.api.getRowIndex(index.row.id) + 1 },
            {
                field: 'category__category_name', headerName: t('Category Name'), flex: 0.23, renderCell: (cellvalues) => {
                    return (
                        <div>{cellvalues?.row?.category__category_name?.length > 20 ? <Tooltip placement="top" title={cellvalues?.row?.category__category_name} arrow><div>{cellvalues?.row?.category__category_name.slice(0, 15) + "..."}</div></Tooltip> : cellvalues?.row?.category__category_name ? cellvalues?.row?.category__category_name : "-"}</div>
                    )
                }
            },
            {
                field: 'sub_category_name', headerName: t('Sub-Category Name'), flex: 0.23, renderCell: (cellvalues) => {
                    return (
                        <div>{cellvalues?.row?.sub_category_name?.length > 20 ? <Tooltip placement="top" title={cellvalues?.row?.sub_category_name} arrow><div>{cellvalues?.row?.sub_category_name.slice(0, 15) + "..."}</div></Tooltip> : cellvalues?.row?.sub_category_name ? cellvalues?.row?.sub_category_name : "-"}</div>
                    )
                }
            },
            {
                field: 'active_status', headerAlign: 'center', headerName: t('Status'), flex: 0.21, align: "center", renderCell: (cellvalues) => {
                    return (
                        <div style={{ color: cellvalues?.row?.active_status ? Colors.themeDark : Colors.red, backgroundColor: "#e2faf9", width: "4.5vw", padding: "0.5vw", borderRadius: "0.3vw", textAlign: "center", fontSize: "0.9vw", fontWeight: "600" }}>
                            {cellvalues?.row?.active_status ? "Active" : "InActive"}
                        </div>
                    )
                }
            },
            {
                field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.15, sortable: false, hideable: false, align: "center", renderCell: (cellvalue) => {
                    return (
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                <CommonEditButton size="1.5vw" onClick={this.handleEdit.bind(this, cellvalue.row)} />
                            </Stack>
                        </Stack>
                    )
                }
            }
        ]
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={7.6}>
                        <Paper className="eMed_srvConfig_Div" >
                            <DataGrid
                                rows={Sub_Category_List}
                                columns={columns}
                                getRowId={(row) => row.id}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                headerHeight={40}
                                disableSelectionOnClick
                                components={{
                                    Toolbar: CommonGridHeader.CommonToolBar,
                                    NoRowsOverlay: () => {
                                        return (
                                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                                {t("NoRecordsFound")}
                                            </Stack>
                                        )
                                    }
                                }}
                                rowCount={Sub_Category_List.length}
                                page={current_page}
                                onPageChange={(newPage) => this.setState({ current_page: newPage })}
                                pageSize={rowsPerPage}
                                onPageSizeChange={(newPageSize) => this.setState({ rowsPerPage: newPageSize })}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                loading={this.state.isLoader}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={4.4}>
                        <Paper className="eMed_srvConfig_Div">
                            <div className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                <p className='eMed_srvConfig_rightHead_txt'>{t("Add New Category")}</p>
                            </div>
                            <div className="eMed_ipPackage_Div" style={{ overflow: "scroll" }}>
                                <div style={{ padding: "1.5vw" }}>
                                    <Autocomplete
                                        disableClearable
                                        size='small'
                                        value={this.state.Category_Name}
                                        options={this.state.CategoryList?.map((item) => item)}
                                        getOptionLabel={(option) => (option?.category_name)}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                Category_Name: newValue,
                                            })
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label={t('Select Category Name')} />
                                        )}
                                    />
                                    <TextField
                                        sx={{ width: "100%", marginTop: "1.35vw" }}
                                        size="small"
                                        inputProps={{ maxLength: 100 }}
                                        autoComplete="off"
                                        label={t("Sub Category Name")}
                                        required
                                        value={this.state.Sub_Category_Name}
                                        onChange={(e) => {
                                            this.setState({ Sub_Category_Name: e.target.value })
                                        }}
                                    />
                                </div>
                                <div style={{ paddingTop: "1vw", paddingLeft: "2vw", borderTop: "1px solid #E3E2E2", marginTop: "0.5vw" }}>
                                    <FormControlLabel checked={this.state.isActive} control={<Checkbox />} onClick={(e) => {
                                        this.setState({ isActive: e.target.checked })
                                    }} label="Active" />
                                </div>
                            </div>
                            <Stack direction="column" sx={{ backgroundColor: Colors.DataTblHeaderbg, height: "7vh" }} alignItems="center" justifyContent="center">
                                <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                                    <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                                    <Button variant='contained' size="small" id="eMed_Config_btn" disabled={this.state.isLoader} onClick={() => { this.handleSave() }}>{t("Add")}</Button>
                                </Stack>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
                {
                    this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {
                    this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
            </Box>
        )
    }
}
export default withTranslation()(AssetSubCategory)